/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useState, useMemo } from 'react'
import { KTIcon } from '../../../helpers'

type KycDocument = {
    docType: string
    docUrl: string
    docNumber: string | null
}

type FacilityData = {
    id: string
    name: string
    address: string
    kycDocuments: KycDocument[]
    collectedVolume?: number
    linkedCustomerCount?: number
    participationRate?: number
    activeCustomers?: number
    topCustomers?: any[]
}

type Props = {
    className: string
    performanceData?: any
}

const TablesWidget19: React.FC<Props> = ({ className, performanceData }) => {
    const [selectedFilter, setSelectedFilter] = useState<'volume' | 'household' | 'participation'>('volume')
    const [topCustomers, setTopCustomers] = useState<any[]>([])
    const [showModal, setShowModal] = useState(false)

    // Get the appropriate data based on selected filter
    const facilitiesData = useMemo(() => {
        const data = performanceData?.data || performanceData

        if (!data) {
            console.log('No performanceData available')
            return []
        }

        let result: FacilityData[] = []

        switch (selectedFilter) {
            case 'volume':
                result = data.topFacilitiesByVolume || []
                break
            case 'household':
                result = data.topFacilitiesByCustomers || []
                break
            case 'participation':
                result = data.topFacilitiesByPerformance || []
                break
            default:
                result = []
        }

        console.log('Selected filter:', selectedFilter)
        console.log('Facilities data:', result)

        return result
    }, [selectedFilter, performanceData])

    // Get POE document image URL
    const getPOEImage = (kycDocuments: KycDocument[]) => {
        if (!kycDocuments || !Array.isArray(kycDocuments)) return ''
        const poeDoc = kycDocuments.find(doc => doc.docType === 'POI')
        return poeDoc?.docUrl || ''
    }
    const getPOFImage = (kycDocuments: KycDocument[]) => {
        if (!kycDocuments || !Array.isArray(kycDocuments)) return ''
        const poeDoc = kycDocuments.find(doc => doc.docType === 'POF')
        return poeDoc?.docUrl || ''
    }

    // Truncate address to 15 characters
    const truncateAddress = (address: string) => {
        if (!address) return 'N/A'
        return address.length > 15 ? address.substring(0, 15) + '...' : address
    }

    // Format participation rate as percentage
    const formatParticipation = (rate?: number) => {
        if (rate === undefined || rate === null) return 'N/A'
        return `${(rate * 100).toFixed(0)}%`
    }

    // Format volume with safety check
    const formatVolume = (volume?: number) => {
        if (volume === undefined || volume === null) return '0.00'
        return volume.toFixed(2)
    }

    // Format household count
    const formatHousehold = (count?: number) => {
        if (count === undefined || count === null) return '0'
        return count.toString()
    }

    const viewFacilityDetails = (topCustomers: any[]) => {
        setTopCustomers(topCustomers)
        setShowModal(true)
    }
    console.log("topCustomers", topCustomers)

    const closeModal = () => {
        setShowModal(false)
        setTopCustomers([])
    }

    // Format number to 2 decimal places
    const formatNumber = (num?: number) => {
        if (num === undefined || num === null) return '0.00'
        return num.toFixed(2)
    }

    return (
        <div>
            <div className={`card ${className}`}>
                {/* begin::Header */}
                <div className='card-header border-0 pt-5'>
                    <h3 className='card-title align-items-start flex-column'>
                        <span className='card-label fw-bold fs-3 mb-1'>Top Material Hubs</span>
                        <span className='text-dark mt-1 fw-semibold fs-7'>
                            {facilitiesData.length} facilities
                        </span>
                    </h3>
                    <div className='card-toolbar'>
                        {/* begin::Menu */}
                        <button
                            type='button'
                            className='btn btn-sm btn-icon btn-color-primary btn-active-light-primary'
                            data-kt-menu-trigger='click'
                            data-kt-menu-placement='bottom-end'
                            data-kt-menu-flip='top-end'
                        >
                            <KTIcon iconName='category' className='fs-2' />
                        </button>
                        {/* begin::Menu 2 */}
                        <div
                            className='menu menu-sub menu-sub-dropdown menu-column menu-rounded menu-gray-600 menu-state-bg-light-primary fw-semibold w-200px'
                            data-kt-menu='true'
                        >
                            {/* begin::Menu item */}
                            <div className='menu-item px-3'>
                                <div className='menu-content fs-6 text-dark fw-bold px-3 py-4'>Filter  by</div>
                            </div>
                            {/* end::Menu item */}
                            {/* begin::Menu separator */}
                            <div className='separator mb-3 opacity-75'></div>
                            {/* end::Menu separator */}
                            {/* begin::Menu item */}
                            <div className='menu-item px-3'>
                                <a
                                    href='#'
                                    className={`menu-link px-3 ${selectedFilter === 'volume' ? 'active' : ''}`}
                                    onClick={(e) => {
                                        e.preventDefault()
                                        setSelectedFilter('volume')
                                    }}
                                >
                                    Plastic Collected
                                </a>
                            </div>
                            {/* end::Menu item */}
                            {/* begin::Menu item */}
                            <div className='menu-item px-3'>
                                <a
                                    href='#'
                                    className={`menu-link px-3 ${selectedFilter === 'household' ? 'active' : ''}`}
                                    onClick={(e) => {
                                        e.preventDefault()
                                        setSelectedFilter('household')
                                    }}
                                >
                                    Household connected
                                </a>
                            </div>
                            {/* end::Menu item */}
                            {/* begin::Menu item */}
                            <div className='menu-item px-3'>
                                <a
                                    href='#'
                                    className={`menu-link px-3 ${selectedFilter === 'participation' ? 'active' : ''}`}
                                    onClick={(e) => {
                                        e.preventDefault()
                                        setSelectedFilter('participation')
                                    }}
                                >
                                    Participation rate
                                </a>
                            </div>
                            {/* end::Menu item */}
                            {/* begin::Menu separator */}
                            <div className='separator mt-3 opacity-75'></div>
                            {/* end::Menu separator */}
                            {/* begin::Menu item */}
                            {/* <div className='menu-item px-3'>
                            <div className='menu-content px-3 py-3'>
                                <a className='btn btn-primary btn-sm px-4' href='#'>
                                    Generate Reports
                                </a>
                            </div>
                        </div> */}
                            {/* end::Menu item */}
                        </div>
                        {/* end::Menu 2 */}
                        {/* end::Menu */}
                    </div>
                </div>
                {/* end::Header */}
                {/* begin::Body */}
                <div className='card-body py-3'>
                    {/* begin::Table container */}
                    <div className='table-responsive'>
                        {/* begin::Table */}
                        <table className='table table-row-dashed table-row-gray-300 align-middle gs-0 gy-4'>
                            {/* begin::Table head */}
                            <thead>
                                <tr className='fw-bold text-dark'>
                                    <th className='ps-4 min-w-30px rounded-start'>Facility</th>
                                    <th className='min-w-100px'>Name</th>
                                    <th className='min-w-150px'>Address</th>
                                    <th className='min-w-100px'>Plastic collected (kg)</th>
                                    <th className='min-w-100px'>Household</th>
                                    <th className='min-w-100px'>Top 5</th>
                                    <th className='min-w-100px rounded-end'>Participation</th>
                                </tr>
                            </thead>
                            {/* end::Table head */}
                            {/* begin::Table body */}
                            <tbody>
                                {facilitiesData.length > 0 ? (
                                    facilitiesData.map((facility) => {
                                        console.log("participationRate", facility)
                                        const pofImageUrl = getPOFImage(facility.kycDocuments)

                                        return (
                                            <tr key={facility.id}>
                                                <td className='ps-4'>
                                                    <div className='symbol symbol-45px'>
                                                        {pofImageUrl ? (
                                                            <img
                                                                src={pofImageUrl}
                                                                alt='Facility'
                                                                className='symbol-label'
                                                                style={{
                                                                    borderRadius: '50%',
                                                                    objectFit: 'cover',
                                                                    width: '45px',
                                                                    height: '45px'
                                                                }}
                                                            />
                                                        ) : (
                                                            <div className='symbol symbol-45px me-5'>
                                                                <div className='symbol-label bg-light-primary text-primary fs-6 fw-bold'>
                                                                    {facility.name?.substring(0, 2)?.toUpperCase()}
                                                                </div>
                                                            </div>
                                                            // <div
                                                            //     className='symbol-label bg-light-primary'
                                                            //     style={{
                                                            //         borderRadius: '50%',
                                                            //         width: '45px',
                                                            //         height: '45px',
                                                            //         display: 'flex',
                                                            //         alignItems: 'center',
                                                            //         justifyContent: 'center'
                                                            //     }}
                                                            // >
                                                            //     <KTIcon iconName='home' className='fs-2 text-primary' />
                                                            // </div>
                                                        )}
                                                    </div>
                                                </td>
                                                <td>
                                                    <a href='#' className='text-dark fw-bold text-hover-primary d-block mb-1 fs-6'>
                                                        {facility.name || 'N/A'}
                                                    </a>
                                                </td>
                                                <td>
                                                    <span
                                                        className='text-dark fw-semibold d-block fs-7'
                                                        title={facility.address || ''}
                                                    >
                                                        {truncateAddress(facility.address)}
                                                    </span>
                                                </td>
                                                <td>
                                                    <a href='#' className='text-dark fw-bold text-hover-primary d-block fs-6'>
                                                        {formatVolume(facility.collectedVolume)}
                                                    </a>
                                                </td>
                                                <td>
                                                    <span className='text-dark fw-bold d-block fs-6'>
                                                        {formatHousehold(facility.linkedCustomerCount)}
                                                    </span>
                                                </td>
                                                <td>
                                                    <button className='btn btn-sm btn-light-primary' onClick={() => viewFacilityDetails(facility?.topCustomers || [])}>
                                                        View
                                                    </button>
                                                </td>
                                                <td className='text-end'>
                                                    <div className='d-flex flex-column w-100 me-2'>
                                                        <div className='d-flex flex-stack mb-2'>
                                                            {facility?.participationRate && facility?.participationRate > 0.75 ? (
                                                                <span className='badge badge-light-success text-success fw-bold fs-7'>
                                                                    {formatParticipation(facility.participationRate)}
                                                                </span>
                                                            ) : facility?.participationRate && facility?.participationRate >= 0.50 ? (
                                                                <span className='badge badge-light-warning text-warning fw-bold fs-7'>
                                                                    {formatParticipation(facility.participationRate)}
                                                                </span>
                                                            ) : (
                                                                <span className='badge badge-light-danger text-danger fw-bold fs-7'>
                                                                    {formatParticipation(facility.participationRate)}
                                                                </span>
                                                            )}
                                                        </div>
                                                        <div className='progress h-6px w-100' style={{ backgroundColor: '#4f45f533' }}>
                                                            <div
                                                                className='progress-bar'
                                                                role='progressbar'
                                                                style={{ width: `${(facility?.participationRate ? +facility?.participationRate : 0) * 100}%`, backgroundColor: '#4f45f5' }}
                                                            ></div>
                                                        </div>
                                                    </div>
                                                </td>
                                            </tr>
                                        )
                                    })
                                ) : (
                                    <tr>
                                        <td colSpan={6} className='text-center py-5'>
                                            <span className='text-dark'>No facilities data available</span>
                                        </td>
                                    </tr>
                                )}
                            </tbody>
                            {/* end::Table body */}
                        </table>
                        {/* end::Table */}
                    </div>
                    {/* end::Table container */}
                </div>
                {/* end::Body */}


            </div>
            {/* begin::Top Customers Modal */}
            {showModal && (
                <>
                    {/* Backdrop */}
                    <div className='modal-backdrop fade show' style={{ zIndex: 1050 }}></div>

                    <div
                        className='modal fade show'
                        id='kt_modal_top_customers'
                        tabIndex={-1}
                        role='dialog'
                        aria-modal='true'
                        style={{
                            display: 'flex',
                            position: 'fixed',
                            top: 0,
                            left: 0,
                            width: '100vw',
                            height: '100vh',
                            zIndex: 1055,
                            alignItems: 'center',
                            justifyContent: 'center',
                            overflow: 'auto',
                        }}
                    >
                        <div className='modal-dialog modal-xl' style={{ margin: '1.75rem auto', }}>
                            <div className='modal-content w-100 h-full'>

                                {/* Header */}
                                <div className='modal-header'>
                                    <h2 className='fw-bold'>Top 5 Households</h2>

                                    <button
                                        type='button'
                                        className='btn btn-sm btn-icon btn-active-color-primary'
                                        onClick={closeModal}
                                    >
                                        <i className='ki-duotone ki-cross fs-1'>
                                            <span className='path1'></span>
                                            <span className='path2'></span>
                                        </i>
                                    </button>
                                </div>

                                {/* Body */}
                                <div className='modal-body py-5 px-10'>

                                    <div className='table-responsive'>
                                        <table className='table table-row-dashed table-row-gray-300 align-middle gs-0 gy-4 '>
                                            <thead>
                                                <tr className='fw-bold text-dark bg-light '>
                                                    <th className='ps-4 min-w-200px rounded-start'>
                                                        Name
                                                    </th>
                                                    <th className='min-w-140px'>Lifetime</th>
                                                    <th className='min-w-180px'>Monthly avg.</th>
                                                    <th className='min-w-180px'>Weekly avg.</th>
                                                    <th className='min-w-180px'>Daily avg.</th>

                                                </tr>
                                            </thead>

                                            <tbody>
                                                {topCustomers.length > 0 ? (
                                                    topCustomers?.slice(0, 5).map((customer, index) => (
                                                        <tr key={customer.customerId || index}>
                                                            <td className='ps-4'>
                                                                <span className='text-dark fw-bold fs-6'>
                                                                    {customer.customerName?.trim() || 'N/A'}
                                                                </span>
                                                            </td>

                                                            <td>
                                                                <span className='text-dark fw-semibold fs-7'>
                                                                    {formatNumber(customer.lifeTimePerformance)}
                                                                </span>
                                                            </td>

                                                            <td>
                                                                <span className='text-dark fw-semibold fs-7'>
                                                                    {formatNumber(customer.avgMonthlyCollected)}
                                                                </span>
                                                            </td>

                                                            <td>
                                                                <span className='text-dark fw-semibold fs-7'>
                                                                    {formatNumber(customer.avgWeeklyCollected)}
                                                                </span>
                                                            </td>

                                                            <td>
                                                                <span className='text-dark fw-semibold fs-7'>
                                                                    {formatNumber(customer.avgDailyCollected)}
                                                                </span>
                                                            </td>
                                                        </tr>
                                                    ))
                                                ) : (
                                                    <tr>
                                                        <td
                                                            colSpan={10}
                                                            className='text-center py-10'
                                                        >
                                                            <span className='text-dark fs-6'>
                                                                No customer data available
                                                            </span>
                                                        </td>
                                                    </tr>
                                                )}
                                            </tbody>
                                        </table>
                                    </div>
                                </div>

                                {/* Footer */}
                                <div className='modal-footer'>
                                    <button
                                        type='button'
                                        className='btn btn-light'
                                        onClick={closeModal}
                                    >
                                        Close
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </>
            )}
        </div>
    )
}

export { TablesWidget19 }